import React, { Component } from 'react';
import { AwesomeButton } from "react-awesome-button";
import "react-awesome-button/dist/styles.css";

export default class About extends Component {
  render() {
    return (
      <React.Fragment>
    {/* About Section
    ================================================== */}
      <section id="about">
        <div className="row">
          <div className="three columns">
            <img className="profile-pic" src="images/profile.jpg" alt />
          </div>
          <div className="nine columns main-col">
            <h2>About Me</h2>
            <p>
              I love solving problems with Machine Learning and Computer Vision. I have been very active in robotics and computer vision projects and it was a sense of achievement to see a system achieve autonomy. It is enlightening to see both hardware and software work in harmony to create a complete system, a system that can react to changes in it's environment without human intervention.
              Although my passion lies in machine learning and computer vision, I am always hungry for knowledge and I am open to all fields of technology. <br/>
              Apart from my aspirations, I am also a fan of sci-fi/ hero shows and a casual gamer. When I have time to kill, I would indulge myself with Marvel comics and shows. I also love playing couch co-op with my friends and families on the console. 
            </p>
            <div className="row">
              <div className="columns contact-details">
                <h2>Contact Details</h2>
                <p className="address">
                  <span>wilsonler62 (Skype)</span><br />
                  <a href="mailto:weisheng.ler@u.nus.edu">weisheng.ler@u.nus.edu</a><br />
                  <a href="mailto:lws803@gmail.com">lws803@gmail.com</a>
                </p>
              </div>
              <div className="columns download">
                <p>
                  {/* <a href="resources/Resume.pdf" className="button"><i className="fa fa-download" />Download Resume</a> */}
                  <AwesomeButton
                    type="secondary"
                    size="large"
                    href="resources/Resume.pdf"
                  >
                    Download Resume
                  </AwesomeButton>

                </p>
              </div>
            </div> {/* end row */}
          </div> {/* end .main-col */}
        </div>
      </section> {/* About Section End*/}

      </React.Fragment>
    );
  }
}
